module.exports = __webpack_public_path__ + "static/parade-2019-house17-a014082dc9c72d42e63d037faf8ca1f9.jpg";